/* eslint-disable no-case-declarations */
export const extractImageUrlFromBlockHero = content =>
	content?.fields?.foregroundImage?.fields?.file?.url || "";

export const extractImagesUrlFromBlockCopy = content => {
	const assetBlocks =
		content?.fields?.text?.content?.filter(({ nodeType }) => nodeType === "embedded-asset-block") ||
		[];

	if (!assetBlocks.length) return [];

	return assetBlocks.map(asset => asset?.data?.target?.fields?.file?.url || "");
};

export const extractImagesUrlFromBlockFeaturedContent = content => {
	const contentReference = content?.fields?.contentReference || [];

	if (!contentReference.length) return [];

	return contentReference.map(item => item?.fields?.thumbnail?.fields?.file?.url || "");
};

export const extractImagesUrlFromBlockVisualCopy = content =>
	content?.fields?.image?.fields?.file?.url || "";

export const extractImagesUrl = content => {
	if (!content || !content.length) return [];

	const imagesUrl = content.reduce((acc, data) => {
		const type = data.sys?.contentType?.sys?.id;

		if (!type) return acc;

		switch (type) {
			case "blockHero":
				const heroImageUrl = extractImageUrlFromBlockHero(data);
				if (heroImageUrl) acc.push(heroImageUrl);
				return acc;

			case "blockCopy":
				const copyImagesUrls = extractImagesUrlFromBlockCopy(data);
				acc.push(...copyImagesUrls);
				return acc;

			case "blockFeaturedContent":
				const featuredContentImagesUrls = extractImagesUrlFromBlockFeaturedContent(data);
				acc.push(...featuredContentImagesUrls);
				return acc;

			case "blockVisualCopy":
				const visualCopyImageUrl = extractImagesUrlFromBlockVisualCopy(data);
				if (visualCopyImageUrl) acc.push(visualCopyImageUrl);
				return acc;

			default:
				return acc;
		}
	}, []);

	return imagesUrl.filter(Boolean);
};
